import React from "react";
import { HelmetProvider } from "react-helmet-async";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SeoFromRoute from "./components/SeoFromRoute";
import GoogleAnalytics from "./components/GoogleAnalytics";
import WhatsAppAssistant from "./components/WhatsAppAssistant";
import JsonLd from "./components/JsonLd";
import { buildLocalBusinessSchema } from "./schema/localBusinessSchema";

// Pages
import Home from "./pages/Home";
import Events from "./pages/Events";
import CorporateEvents from "./pages/events/CorporateEvents";
import WeddingEvents from "./pages/events/WeddingEvents";
import SocialEvents from "./pages/events/SocialEvents";
import BirthdayEvents from "./pages/events/BirthdayEvents";
import ConcertEvents from "./pages/events/ConcertEvents";
import OtherEvents from "./pages/events/OtherEvents";
import Production from "./pages/Production";
import DecorAtelier from "./pages/production/DecorAtelier";
import StallDesign from "./pages/production/StallDesign";
import Photography from "./pages/production/Photography";
import PhotoBooth from "./pages/production/PhotoBooth";
import Catering from "./pages/production/Catering";
import AVEquipments from "./pages/production/AVEquipments";
import SpecialEffects from "./pages/production/SpecialEffects";
import ArtistManagement from "./pages/production/ArtistManagement";
import KidsZone from "./pages/production/KidsZone";
import InvitationCard from "./pages/production/InvitationCard";
import GalleryPage from "./pages/EventGallery";
import Blogs from "./pages/Blogs";
import BlogPostPage from "./pages/BlogPostPage";
import Reviews from "./pages/Reviews";
import ContactUs from "./pages/ContactUs";
import Contacts from "./pages/Contacts";
import LocalLandingPage from "./pages/LocalLandingPage";
import NotFound from "./pages/NotFound";

function AppRoutes() {
  const { pathname } = useLocation();
  const hideSiteChrome = pathname === "/contacts";

  return (
    <div className="App">
      {!hideSiteChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/corporate-events" element={<CorporateEvents />} />
        <Route path="/wedding-events" element={<WeddingEvents />} />
        <Route path="/social-events" element={<SocialEvents />} />
        <Route path="/birthday-events" element={<BirthdayEvents />} />
        <Route path="/concert-events" element={<ConcertEvents />} />
        <Route path="/other-events" element={<OtherEvents />} />
        <Route
          path="/events/corporate"
          element={<Navigate to="/corporate-events" replace />}
        />
        <Route
          path="/events/wedding"
          element={<Navigate to="/wedding-events" replace />}
        />
        <Route
          path="/events/social"
          element={<Navigate to="/social-events" replace />}
        />
        <Route
          path="/events/birthday"
          element={<Navigate to="/birthday-events" replace />}
        />
        <Route
          path="/events/concert"
          element={<Navigate to="/concert-events" replace />}
        />
        <Route
          path="/events/other"
          element={<Navigate to="/other-events" replace />}
        />
        <Route path="/production" element={<Production />} />
        <Route path="/production/decor-atelier" element={<DecorAtelier />} />
        <Route path="/production/stall-design" element={<StallDesign />} />
        <Route path="/production/photography" element={<Photography />} />
        <Route path="/production/photo-booth" element={<PhotoBooth />} />
        <Route path="/production/catering" element={<Catering />} />
        <Route path="/production/av-equipments" element={<AVEquipments />} />
        <Route
          path="/production/special-effects"
          element={<SpecialEffects />}
        />
        <Route
          path="/production/artist-management"
          element={<ArtistManagement />}
        />
        <Route path="/production/kids-zone" element={<KidsZone />} />
        <Route
          path="/production/invitation-card"
          element={<InvitationCard />}
        />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogPostPage />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route
          path="/event-management-ahmedabad"
          element={<LocalLandingPage slug="event-management-ahmedabad" />}
        />
        <Route
          path="/wedding-planner-ahmedabad"
          element={<LocalLandingPage slug="wedding-planner-ahmedabad" />}
        />
        <Route
          path="/corporate-event-ahmedabad"
          element={<LocalLandingPage slug="corporate-event-ahmedabad" />}
        />
        <Route
          path="/event-gallery"
          element={<Navigate to="/gallery" replace />}
        />
        <Route
          path="/testimonials"
          element={<Navigate to="/reviews" replace />}
        />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideSiteChrome && <Footer />}
      {!hideSiteChrome && <WhatsAppAssistant />}
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <JsonLd data={buildLocalBusinessSchema()} />
        <SeoFromRoute />
        <GoogleAnalytics />
        <AppRoutes />
      </Router>
    </HelmetProvider>
  );
}

export default App;
